<template>
  <div class="ccui-help-center">
    <div class="ccui-app-container">
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <div class="ccui-search-wrapper ccui-clearfix">
          <!--普通搜索Begin-->
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">帮助中心</el-button>
          </div>

          <!--普通搜索End-->
        </div>
      </div>
      <div class="ccui-help-content-box">
        <ul>
          <li>
            <img src="@/assets/images/commonProblem.png" alt="" />
            <dl>
              <dt>常见问题</dt>
              <dd>您有问题可先看这里</dd>
            </dl>
            <el-button size="mini" type="primary" @click="goCommonProblem"
              >点此查看</el-button
            >
          </li>
          <li>
            <img src="@/assets/images/usersManual.png" alt="" />
            <dl>
              <dt>用户手册</dt>
              <dd>爱学习的人都会来看看这里</dd>
            </dl>
            <el-button size="mini" type="primary" @click="goUsersManual"
              >点此查看</el-button
            >
          </li>
          <li>
            <img src="@/assets/images/onlineService.png" alt="" />
            <dl>
              <dt>在线客服</dt>
              <dd>在线解答您的咨询，高效、便捷</dd>
            </dl>
            <el-button size="mini" type="primary" @click="goOnlineService"
              >点此咨询</el-button
            >
          </li>
          <li>
            <img src="@/assets/images/proposal.png" alt="" />
            <dl>
              <dt>提建议</dt>
              <dd>对购物车应用提建议</dd>
            </dl>
            <el-button size="mini" type="primary" @click="goProposal"
              >我要留言</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "heplCenter",
  computed: {
    changeRole(roleType) {
      return function(roleType) {
        /** do something */
        return roleType !== 1 && roleType !== 0;
      };
    }
  },
  data() {
    return {
      appId: "0"
    };
  },
  created() {
    this.$store.dispatch("setShowSimpleFooter", true);
    this.$store.dispatch("setShowisEmpFooter", false);
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setShowSimpleFooter", true);
    this.$store.dispatch("setShowisEmpFooter", false);
    next();
  },
  methods: {
    goCommonProblem() {
      this.$router.push("/helpAndSupport/helpProblem");
    },
    goUsersManual() {
      this.$router.push("/helpAndSupport/helpManual");
    },
    goOnlineService() {},
    goProposal() {}
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// @media screen and (max-width: 1280px) {
//   .ccui-help-center-wrap {
//     width: 1040px;
//   }
// }
// @media screen and (min-width: 1281px) {
//   .ccui-help-center-wrap {
//     width: 1180px;
//     margin: 0 auto;
//   }
// }
</style>
